// extracted by mini-css-extract-plugin
module.exports =  {"root":"wTkVX_q0rMixr3n35F9C"};